import * as t from 'io-ts';
import * as E from 'fp-ts/lib/Either';

/** Currently we only need to support Finish and Dimension properties as configurable */
export const Finish = t.intersection([
    t.type({
        name: t.string,
    }),
    t.partial({
        colour: t.string,
        image: t.string,
    }),
]);

export const DimensionValue = t.type({ value: t.number, label: t.string, unit: t.string });
export const Dimension = t.type({ x: DimensionValue, y: DimensionValue, z: DimensionValue });

export type FinishT = t.TypeOf<typeof Finish>;
export type DimensionT = t.TypeOf<typeof Dimension>;

export const isFinish = (f: unknown): f is FinishT => {
    return E.isRight(Finish.decode(f));
};

export const isDimension = (f: unknown): f is DimensionT => {
    return E.isRight(Dimension.decode(f));
};

export const Gift = t.record(
    t.string,
    t.type({ isGlobal: t.boolean, label: t.string, type: t.string }),
);

export type Gift = t.TypeOf<typeof Gift>;

export const ConfigurablePropertySelection = t.type({
    propertyKey: t.string,
    finish: Finish,
});

export type ConfigurablePropertySelectionT = t.TypeOf<typeof ConfigurablePropertySelection>;

export const finishesEqual = (a: FinishT, b: FinishT): boolean => {
    const coloursEqual = a.colour && b.colour ? a.colour === b.colour : true;
    const imagesEqual = a.image && b.image ? a.image === b.image : true;
    return a.name === b.name && coloursEqual && imagesEqual;
};

export const getPropertyMap = (giftConfigurableProperties: Gift) => {
    return Object.entries(giftConfigurableProperties).reduce((props, [key, value]) => {
        if (!props[key]) {
            props[key] = value.label;
        }
        return props;
    }, {} as Record<string, string>);
};

export const getGlobals = (giftConfigurableProperties: Gift) => {
    return Object.keys(giftConfigurableProperties);
};
